import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import style from './search-page-layout.module.scss';

interface Props {
  mapSection: ReactNode;
  resultsSection: ReactNode;
  mapHeightPercent: number;
  divider: ReactNode;
  showMap?: boolean;
  showTable?: boolean;
}

const SearchPageLayout: FC<Props> = ({
  mapSection,
  resultsSection,
  mapHeightPercent,
  divider,
  showMap = true,
  showTable = true,
}) => {
  return (
    <div className={style.layout}>
      {showMap && (
        <div
          className={classNames(style.mapArea, {
            [style.flexFull]: !showTable,
          })}
          style={showTable ? { flex: `0 0 ${mapHeightPercent}%` } : undefined}
        >
          {mapSection}
        </div>
      )}
      {showMap && showTable && divider}
      {showTable && (
        <div
          className={classNames(style.resultsArea, {
            [style.flexFull]: !showMap,
          })}
        >
          {resultsSection}
        </div>
      )}
    </div>
  );
};

export { SearchPageLayout };
